var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#ED4444;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,20.8c-1.6,1.4-2.7,3.2-3.2,5.3h3.8c0.3-1.9,0.7-3.7,1.5-5.4h-1.9C23.3,20.8,23.3,20.8,23.1,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.9,15.4H24.1c-4.4,0-8.7,4.3-8.7,8.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7c0-3.4,3.3-6.9,6.7-7.3v2.6h8.1 v-2.7h3.1c-0.3,0.4-0.4,0.9-0.4,1.3c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7S38.4,15.4,36.9,15.4z M36.9,19.4 c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3C38.3,18.8,37.7,19.4,36.9,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.8,20.8c-0.9,1.7-1.4,3.5-1.7,5.4h4.8c-0.3-1.9-0.9-3.7-1.7-5.4H26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.4,27.5c0.1,0.9,0.1,1.7,0.1,2.7c0,0.9-0.1,1.8-0.1,2.7h3.9c0.1-0.9,0.3-1.8,0.3-2.7s-0.1-1.8-0.2-2.7H31.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.8,30.2c0,0.9,0.1,1.8,0.1,2.7h5.1c0.1-0.9,0.1-1.7,0.1-2.7c0-0.9-0.1-1.8-0.1-2.7h-5.1 C24.9,28.4,24.8,29.2,24.8,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,26.2c-0.5-2.1-1.6-3.9-3.2-5.3c-0.1-0.1-0.2-0.1-0.3-0.1h-1.8c0.7,1.7,1.3,3.5,1.5,5.4H35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.1,34.2c0.3,1.9,0.9,3.7,1.7,5.4h1.3c0.9-1.7,1.4-3.5,1.7-5.4H25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20,34.2c0.5,2,1.6,3.8,3.2,5.2c0.1,0.1,0.3,0.1,0.5,0.1h1.7c-0.7-1.7-1.3-3.5-1.5-5.4H20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.7,39.6h1.7c0.1,0,0.3-0.1,0.5-0.1c1.5-1.4,2.6-3.2,3.2-5.2h-3.8C31,36.1,30.5,37.9,29.7,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.5,30.2c0-0.9,0.1-1.8,0.1-2.7h-3.9c-0.2,0.9-0.3,1.8-0.3,2.7s0.1,1.8,0.3,2.7h3.9 C23.5,32,23.5,31.1,23.5,30.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/threat.9ad95496484c49767d51c4d7d841a8f5.svg";